import { D as DotsLoader, d as defineCustomElement$1 } from './p-960dd019.js';
const OramaDotsLoader = DotsLoader;
const defineCustomElement = defineCustomElement$1;
export { OramaDotsLoader, defineCustomElement }; //# sourceMappingURL=orama-dots-loader.js.map
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib3JhbWEtZG90cy1sb2FkZXIuanMiLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiJ9